<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <el-button type="primary" @click="handleExport">导出</el-button>
      <el-button type="success" @click="batchReview">批量审核</el-button>
    </com-search>
    <com-card>
      <div class="flex items-start mb-5px">
        <h4 class="mt-12px">审核状态</h4>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="item.label"
            :name="item.value"
            v-for="item in statusTag"
            :key="item.value"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="mt-8px">
        <user-withdrawal-list
          :defaultParams="defaultParams"
          :isShowCheck="activeName === '0'"
          @audit="handleAudit"
          @detail="handleDetail"
          @repair="handleRepair"
          ref="table"
        ></user-withdrawal-list>
      </div>
    </com-card>
    <the-check-dialog ref="checked" @success="init"></the-check-dialog>
    <user-withdrawal-detail ref="detail"></user-withdrawal-detail>
    <user-withdrawal-repair-dialog ref="repair" @success="init"></user-withdrawal-repair-dialog>
  </com-page>
</template>

<script>
import userWithdrawalList from './components/user-withdrawal-list'
import theCheckDialog from './components/user-withdrawal-check-dialog'
import userWithdrawalDetail from './components/user-withdrawal-detail'
import userWithdrawalRepairDialog from './components/user-withdrawal-repair-dialog'

export default {
  components: { userWithdrawalList, theCheckDialog, userWithdrawalDetail, userWithdrawalRepairDialog },
  data() {
    return {
      activeName: '-1',
      defaultParams: {
        auditStatus: null
      },
      statusTag: [
        {
          label: '全部',
          value: '-1'
        },
        {
          label: '待审核',
          value: '0'
        },
        {
          label: '通过',
          value: '1'
        },
        {
          label: '拒绝',
          value: '2'
        }
      ],
      searchColumns: [
        {
          label: '订单编号',
          prop: 'number',
          type: 'input'
        },
        {
          label: '用户ID/手机号',
          prop: 'userCondition',
          type: 'input'
        },
        {
          label: '网点',
          prop: 'refUserRegisterStoreName',
          type: 'input'
        },
        {
          label: '退款状态',
          prop: 'refundStatus',
          type: 'select',
          option: [
            {
              label: '退款中',
              value: 0
            },
            {
              label: '退款成功',
              value: 1
            },
            {
              label: '退款失败',
              value: 2
            }
          ]
        },
        {
          label: '提现时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    handleClick() {
      console.log('val :>> ', this.activeName)
      if (this.activeName === '-1') {
        this.defaultParams.auditStatus = ''
      } else {
        this.defaultParams.auditStatus = +this.activeName
      }
      this.$refs.table.init()
    },
    handleAudit(row) {
      this.$refs.checked.open(row)
    },
    handleDetail(row) {
      this.$refs.detail.open(row)
    },
    handleRepair(row) {
      this.$refs.repair.open(row)
    },
    handleSearch(val) {
      const params = {
        ...val,
        queryBeginTime: val.beginTime,
        queryEndTime: val.endTime
      }
      this.$refs.table.search(params)
    },
    init() {
      this.$refs.table.init()
    },

    batchReview() {
      const selectedList = this.$refs.table.getSelectedList()
      if (!selectedList.length) {
        this.$message.warning('请选择审核项')
        return
      }
      const params = {
        type: 'batch',
        userWithdrawCodeList: selectedList.map(item => item.refStore),
      }
      this.handleAudit(params)
    },

    handleExport() {
      this.$refs.table.handleExport()
    }
  }
}
</script>

<style lang="scss" scoped></style>
